
export const active = "white"
export const inactive = "#5E5E5E"

export const home = (color: string) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
    <path
        d="M13.8418 2.16563C12.7585 1.32304 11.2415 1.32305 10.1582 2.16564L3.15818 7.61008C2.42742 8.17845 2 9.05237 2 9.97814V20C2 21.6568 3.34315 23 5 23H19C20.6569 23 22 21.6568 22 20V9.97814C22 9.05236 21.5726 8.17845 20.8418 7.61008L13.8418 2.16563Z"
        fill={color}/>
    <path
        d="M9 14C9 12.8954 9.89543 12 11 12H13C14.1046 12 15 12.8954 15 14V19C15 19.5523 14.5523 20 14 20H10C9.44772 20 9 19.5523 9 19V14Z"
        fill={color === active ? "#5e5e5e" : "#000"}/>
</svg>


export const friends = (color: string) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1.66504 17.1485C1.95761 17.454 2.41078 17.5424 2.79671 17.3692C3.18265 17.196 3.41786 16.7987 3.3841 16.377C3.27105 14.9651 3.7538 13.5183 4.83251 12.4396L9.39327 7.87884L11.2218 9.7074C11.5078 9.9934 11.9379 10.079 12.3116 9.92417C12.6853 9.76939 12.9289 9.40475 12.9289 9.00029L12.9289 2.00024C12.9289 1.73503 12.8236 1.48067 12.636 1.29314C12.4485 1.1056 12.1941 1.00024 11.9289 1.00024H4.92892C4.52446 1.00024 4.15982 1.24389 4.00504 1.61756C3.85026 1.99123 3.93581 2.42135 4.22181 2.70735L6.01462 4.50017L1.75731 8.75758C-0.554593 11.0695 -0.585361 14.7985 1.66504 17.1485Z"
        fill={color}/>
    <path
        d="M22.2639 6.85177C21.9713 6.54625 21.5181 6.45787 21.1322 6.63107C20.7463 6.80426 20.5111 7.20156 20.5448 7.62322C20.6579 9.03512 20.1751 10.482 19.0964 11.5607L14.5357 16.1214L12.7071 14.2928C12.4211 14.0068 11.991 13.9213 11.6173 14.0761C11.2436 14.2309 11 14.5955 11 15L11 22C11 22.2652 11.1054 22.5196 11.2929 22.7071C11.4804 22.8946 11.7348 23 12 23H19C19.4045 23 19.7691 22.7564 19.9239 22.3827C20.0787 22.009 19.9931 21.5789 19.7071 21.2929L17.9143 19.5001L22.1716 15.2427C24.4835 12.9307 24.5143 9.20178 22.2639 6.85177Z"
        fill={color}/>
</svg>

export const tasks = (color: string) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="3" width="4" height="4" rx="2" fill={color}/>
    <rect x="1" y="10" width="4" height="4" rx="2" fill={color}/>
    <rect x="1" y="17" width="4" height="4" rx="2" fill={color}/>
    <rect x="8" y="3" width="15" height="4" rx="2" fill={color}/>
    <rect x="8" y="10" width="15" height="4" rx="2" fill={color}/>
    <rect x="8" y="17" width="15" height="4" rx="2" fill={color}/>
</svg>

export const catalog = (color: string) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="8.5" height="8.5" rx="3" fill={color}/>
    <rect x="13.5" y="2" width="8.5" height="8.5" rx="3" fill={color}/>
    <rect x="2" y="13.5" width="8.5" height="8.5" rx="3" fill={color}/>
    <rect x="13.5" y="13.5" width="8.5" height="8.5" rx="3" fill={color}/>
</svg>

export const wallet = (color: string) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                              xmlns="http://www.w3.org/2000/svg">
    <path
        d="M18 2H6C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V5C21 3.34315 19.6569 2 18 2Z"
        fill={color === active ? "#5e5e5e" : "#000"}/>
    <path
        d="M20 5C21.6569 5 23 6.34315 23 8V19C23 20.6569 21.6569 22 20 22H4C2.34315 22 1 20.6569 1 19L1 8C1 6.34314 2.34315 5 4 5L20 5Z"
        fill={color}/>
    <path
        d="M14 13C14 11.8954 14.8954 11 16 11H20C20.5523 11 21 11.4477 21 12V15C21 15.5523 20.5523 16 20 16H16C14.8954 16 14 15.1046 14 14V13Z"
        fill={color === active ? "#5e5e5e" : "#000"}/>
</svg>

export const profile = (color: string) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="7" r="5" fill={color}/>
    <path fillRule="evenodd" clipRule="evenodd" d="M5.31169 21.6334C3.62732 20.9118 2.94387 18.8776 4.05843 17.4231C5.88608 15.038 8.76383 13.5 12.0008 13.5C15.2378 13.5 18.1155 15.038 19.9432 17.4231C21.0578 18.8776 20.3743 20.9118 18.6899 21.6334C16.6369 22.513 14.3757 23 12.0008 23C9.62589 23 7.36471 22.513 5.31169 21.6334Z" fill={color}/>
</svg>

